export const ALTA = "A";
export const CONSULTA = "C";
export const MODIFICACION = "M";
